'use strict';

var classNames = require('classnames');
var Backbone = require('backbone');
var _ = require('underscore');
var Config = require('js/config');
var AdvertMixin = require('js/mixins/adverts');

module.exports = {
  setupModels: function() {
    // Force an update of our application when context is synced
    this.attachModel('context', this.ctx, 'sync');
  },

  scrollToTop: function() {
    document.body.scrollTop = 0;
    if (this.refs && this.refs.container) {
      this.refs.container.scrollTop = 0;
    }
    if (this.refs && this.refs.top) {
      this.refs.top.scrollTop = 0;
    }
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  },

  /**
   * When component has been inserted into the dom
   */
  componentDidMount: function() {
    Backbone.on('view:scrollToTop', this.scrollToTop, this);
    // Set up Google Publisher Tag for Google Ad Manager ads
    // advert:refresh is triggered in updatePage()
    Backbone.on('advert:refresh', AdvertMixin.setupGPT, this);

    window.addEventListener('scroll', this.onScroll);

    if (!this.props.preventScroll) {
      this.scrollToTop();
    }
  },

  /**
   * When component is about to be removed from the dom
   */
  componentWillUnmount: function() {
    Backbone.off(null, null, this);
    window.removeEventListener('scroll', this.onScroll);
  },

  /**
   * When scroll event occurs on the window
   */
  onScroll: function() {
    var showScroll = this.state && this.state.showScroll;
    var scrollTop = this.getScrollTop();

    // Are we scrolled down the page?
    if (!showScroll && scrollTop > 0) {
      this.setState({showScroll: true});
    } else if (showScroll && scrollTop === 0) {
      this.setState({showScroll: false});
    }

    // If we are under a viewport s height away from the bottom inform potential infinite scroll listeners
    if ((scrollTop + (window.innerHeight * 2)) > (this.getDocHeight() - Config.style.footerHeight)) {
      Backbone.trigger('view:scrollNearBottom');
    }
  },

  /**
   * Return the layouts s scroll position
   */
  getScrollTop: function() {
    return window.pageYOffset;
  },

  /**
   * Return the document height
   */
  getDocHeight: function() {
    var D = document;
    return Math.max(
      D.body.scrollHeight, D.documentElement.scrollHeight,
      D.body.offsetHeight, D.documentElement.offsetHeight,
      D.body.clientHeight, D.documentElement.clientHeight
    );
  },

  /**
   * When a click event happens at the very highest level
   */
  onClick: function(event) {
    Backbone.trigger('view:hideSidebar');
    Backbone.trigger('view:unhandledClick', event);
  },

  /**
   * Get the page data for this layout (extend with user data)
   */
  getPageData: function(pageData) {
    return _.extend({
      res: this.app.res,
    }, this.props.pageData, pageData);
  },

  /**
   * When back to top button is clicked
   */
  onBackToTopClick: function() {
    Backbone.trigger('view:scrollToTop');
  },

  /**
   * Generate default className
   */
  getDefaultClassName: function() {
    return classNames({
      'body-container': true,
      'layout-app': true,
    });
  },
};



// WEBPACK FOOTER //
// ./app/assets/js/mixins/layout.js